import {Component, Inject, Input, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ArtigosService} from 'app/shared/services/artigos/artigos.service';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ArtigosTipos} from '../../../../shared/models/artigos/artigostipos';
import {Unidade} from '../../../../shared/models/aplicacao/unidade';
import {Subscription} from 'rxjs';
import {ArtigoNatureza} from '../../../../shared/models/artigos/artigoNatureza';
import {TipoDocumento} from '../../../../shared/models/financas/documentos/documentosTipos';
import {LoginService} from '../../../../shared/services/aplicacao-service/login.service';
import {ArtEstado} from '../../../../shared/models/artigos/art-estado';
import {EstadoArtigosService} from '../../../../shared/services/artigos/EstadoArtigos.service';
import {NotificacaoService} from '../../../../shared/services/notificacao/notificacao.service';
import {ArtigoClassificacao} from '../../../../shared/models/artigos/artigo-classificacao';
import {Util} from '../../../../shared/models/generico/util';
import {CurrencyPipe} from '@angular/common';
import {Opc} from '../../../../shared/models/ENUM';
import {Format} from '@directives/input-format.directive';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'modal-adicionar-artigo-fa',
    templateUrl: './modal-adicionar-artigo-fa.component.html',
    styleUrls: ['./modal-adicionar-artigo-fa.component.scss'],
    providers: [CurrencyPipe]
})
export class ModalAdicionarArtigoFaComponent implements OnInit, OnDestroy {
    readonly format = Format;
    loading = false;
    subs: Subscription[] = [];
    form: FormGroup = this.fb.group({
        nomeArtigo: ['', Validators.required],
        idTipoArtigo: null,
        idEstadoArtigo: [1, [Validators.required, Validators.min(1)]],
        idSubTipoArtigo: [0, Validators.min(0)],
        codigoArtigo: ['', Validators.required],
        codigoTipoArtigo: '',
        descricao: '',
        gereEstoque: false,
        precoArtigo: [this.currencyPipe.transform(0, '', ''), Validators.min(0)],
        idImposto: [0, Validators.required],
        idUnidadeMedida: [1, [Validators.required, Validators.min(1)]]
    });

    classificacao!: ArtigoClassificacao;
    tipos: ArtigosTipos[] = [];
    impostos: any[] = [];
    unidades: Unidade[] = [];
    naturezas: ArtigoNatureza[] = [];
    tipoDocumento: TipoDocumento;
    idClassificacao = 2;
    @Input() tituloModal = 'Adicionar';
    dataHoje = new Date();
    estados: ArtEstado[] = [];
    classificacoes: ArtigoClassificacao[] = [];
    codIdioma = 'pt';
    submitted = false;
    selecionado = false;
    gereStock = false;

    constructor(
        private artigoService: ArtigosService,
        private fb: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public dadosModal: any,
        private loginService: LoginService,
        private alertService: NotificacaoService,
        private currencyPipe: CurrencyPipe,
        private modal: MatDialog,
        private modalRef: MatDialogRef<ModalAdicionarArtigoFaComponent>,
        private estadoArtigoService: EstadoArtigosService
    ) {
        // Get tipo documento

        // get Natureza
        if (dadosModal.tipoDocumento) {
            this.setNaturezas(dadosModal.tipoDocumento.codNatureza);
        }
        this.buscarUnidadeMedida();
    }

    ngOnInit(): void {
        this.gereStock = JSON.parse(localStorage.getItem('gereStocks'));
        this.setEstados(this.idClassificacao);
        this.setIVAs('ao');
        this.setClassificacoes();
    }

    setEstados(idClassificacao: number) {
        this.subs.push(this.estadoArtigoService.getEstados(idClassificacao).subscribe((res: any) => {
            this.estados = res.objecto;
        }, (erro: any) => {
            console.error('ERRO: ', erro);
        }));
    }

    buscarUnidadeMedida() {
        this.loading = true;
        this.subs.push(
            this.artigoService.buscarUnidadeMedida().subscribe((res: any) => {
                this.loading = false;
                this.unidades = res.objecto;
            }, (erro: any) => {
                console.error('ERRO: ', erro);
            })
        );
    }

    setTipos(idClassificacao: number, codIdioma: string) {
        this.loading = true;
        this.subs.push(
            this.artigoService.getTipos(idClassificacao, codIdioma).subscribe((res: any) => {
                this.loading = false;
                this.tipos = res.objecto;
            })
        );
    }

    setNaturezas(codNatureza: string) {
        this.loading = true;
        this.subs.push(
            this.artigoService.getTodosTiposArtigo().subscribe((res: any) => {
                this.loading = false;
                this.naturezas = this.classificacao.codNatureza ?
                    res.filter(t => t.codNatureza === this.classificacao.codNatureza && t.activo)
                    : res.filter(t => t.activo);
                this.f['idTipoArtigo']
                    .patchValue(this.naturezas.length === 1 ? this.naturezas[0]?.idTipoArtigo : null);
            })
        );
    }

    setIVAs(codPais: string) {
        this.subs.push(
            this.artigoService.getArtigoIva(codPais).subscribe((res: any) => {
                this.impostos = res;
            })
        );
    }

    setClassificacoes() {
        this.loading = true;
        this.subs.push(
            this.artigoService.getClassificacoesArtigos().subscribe(res => {
                    this.classificacoes = res.filter(c => ['S', 'P', null, undefined].includes(c.codNatureza));
                    this.classificacao = this.classificacoes.length === 1 ? this.classificacoes[0] : null;
                    this.tituloModal = 'Adicionar ' + (this.classificacao?.classificacaoS ?? '');
                    this.loading = false;
                },
                err => {
                    this.loading = false;
                    this.alertService.notificar(err.error.mensagem || err.mensagem, false, 3000);
                })
        );
    }

    getCodigoArtigo(classificacao: ArtigoClassificacao, data: string, idTipoArtigo: number) {
        this.loading = true;
        this.subs.push(
            this.artigoService.getCodigoArtigo(classificacao.idClassificacao, data, idTipoArtigo).subscribe(() => {
                this.loading = false;
            })
        );
    }

    submit() {
        this.submitted = true;

        if (this.form.invalid) {
            return;
        }

        this.loading = true;
        const payload = {
            idArtigo: 0,
            descricao: this.form.value.nomeArtigo,
            dataCriacao: this.dataHoje,
            composicoes: [],
            composicoesRemover: [],
            descricaoTextos: [
                {
                    codIdioma: 'pt',
                    condicoesAdesao: '',
                    descricao: this.form.value.nomeArtigo,
                    descricaoLonga: null,
                    informacaoAdicional: ''
                }
            ],
            idCategorias: [],
            idCategoriasRemover: [],
            idCriador: +this.loginService.decodedToken.nameid,
            idModificador: +this.loginService.decodedToken.nameid,
            idEstado: 1,
            codArtigo: this.form.value.codigoArtigo,
            idClassificacao: this.classificacao.idClassificacao,
            idTipo: this.form.value.idSubTipoArtigo,
            idTipoArtigo: this.form.value.idTipoArtigo,
            preco1: Util.convertToFloat(this.form.value.precoArtigo),
            preco2: 0,
            preco3: 0,
            precos: [
                {
                    idArtigo: 0,
                    idArtigoPreco: 0,
                    idEmpresa: this.dadosModal.idEmpresa,
                    preco1: Util.convertToFloat(this.form.value.precoArtigo),
                    preco2: 0,
                    preco3: 0,
                    idMoeda: 1,
                    precoIva: true,
                    dataFim: null,
                    dataInicio: null,
                    idModificador: +this.loginService.decodedToken.nameid,
                    idRegistoArtVar: 0,
                    precoEntidadeTipos: []
                }
            ],
            eliminarPrecos: [],
            descricaoLonga: null,
            condicoesAdesao: '',
            informacaoAdicional: '',
            imagem: '',
            idUnidadeMedida: this.form.value.idUnidadeMedida,
            idImposto: this.form.value.idImposto,
            produto: this.classificacao.codNatureza === 'P',
            quantidade: 0,
            listaFornecedores: [],
            sujeitoAretencoes: false,
            idRetencao: 0,
            imagens: [],
            codTipoArtigo: this.classificacao.codNatureza ??
                this.naturezas.find(n => n.idTipoArtigo === this.f['idTipoArtigo'].value)?.codNatureza,
            usaVariante: false,
            idVariante: 0,
            codIdioma: 'PT',
            porMarcacao: this.classificacao.idOpcMarcacao === Opc.OBRIGATORIO && this.classificacao.codNatureza === 'S',
            renovavel: false,
            renovavelMultiplo: false,
            gereEstoque: this.f['gereEstoque'].value,
            devolucao: false,
            variantesValoresDto: [],
            variantesValoresEliminar: [],
            listaImagensRemover: [],
            disponivelOnline: false,
            destaque: false,
            arquivos: [],
            arquivosRemover: [],
            utilizador: this.loginService.getUtilizadorSessao(),
            realizacoes: [],
            realizacoesRemover: [],
            modulos: [],
            modulosRemover: [],
            colaboracoes: [],
            colaboracoesRemover: [],
            artigoEntidades: [],
            artigoEntidadesRemover: [],
            usaAvaliacaoRealizacao: false,
            usaAvaliacaoRealizacaoModulos: false,
            usaCertificado: false
        };

        this.subs.push(
            this.artigoService.gravarArtigo(payload).subscribe((res: any) => {
                    this.loading = false;
                    this.alertService.notificar(res.mensagem, true, 4000);
                    this.form.reset({
                        nomeArtigo: '',
                        idTipoArtigo: 0,
                        idEstadoArtigo: 1,
                        idSubTipoArtigo: 0,
                        codigoArtigo: '',
                        codigoTipoArtigo: '',
                        descricao: '',
                        precoArtigo: this.currencyPipe.transform(0, '', ''),
                        idImposto: this.classificacao?.idIva ?? 0,
                        idUnidadeMedida: this.classificacao?.idUnidadeMedidaDefault ?? 0
                    });
                    this.form.updateValueAndValidity();
                    this.form.markAsPristine();
                    res.objecto.codUnidade = this.unidades.find(u => u.idUnidade === res.objecto.idUnidadeMedida).codUnidade;
                    this.modalRef.close(res.objecto);
                },
                err => {
                    this.loading = false;
                    this.alertService.notificar(err.error?.mensagem, false, 4000);
                })
        );
    }

    seleccionarClassificacao(classificacao: ArtigoClassificacao) {
        this.selecionado = this.selecionado ? this.selecionado : !this.selecionado;
        this.classificacao = classificacao;
        if (classificacao.codigoTamanho > 0) {
            this.f['codigoArtigo'].addValidators([
                Validators.minLength(classificacao.codigoTamanho), Validators.maxLength(classificacao.codigoTamanho)
            ]);
            this.f['codigoArtigo'].updateValueAndValidity();
        }
        if (classificacao.codigoSequencial) {
            this.artigoService.getCodigo(classificacao.idClassificacao).subscribe({
                next: res => this.f['codArtigo'].patchValue(res.objecto),
                error: err => {
                    console.error(err);
                    this.alertService.notificar(err.error?.mensagem || 'Falha inesperada ao gerar o código');
                }
            });
        }
        this.f['idImposto'].patchValue(classificacao.idIva ?? 0);
        this.tituloModal = 'Adicionar ' + (classificacao?.classificacaoS ?? '');
        this.setNaturezas(classificacao?.codNatureza);
        this.setTipos(classificacao?.idClassificacao, this.codIdioma);
        this.setEstados(classificacao.idClassificacao);
    }

    ngOnDestroy() {
        this.subs.forEach(s => s.unsubscribe());
    }

    aoSeleccionarTipoArtigo(tipoArtigo: any) {
        if (this.classificacao.codigoSequencial && this.classificacao.codigoAno && !this.classificacao.codigoTipo) {
            this.getCodigoArtigo(this.classificacao, Util.strParaDataISO(this.dataHoje), tipoArtigo.idTipoArtigo);
        }
    }

    get f() {
        return this.form.controls;
    }
}
